import { combine } from 'effector';
import { $cardLists } from './index';
import { cardListArh$ } from '../../components/RightMenu/CardArchival/model';

export const $hasCyrillicCard = combine(
  { cardLists: $cardLists },
  ({ cardLists }) => {
    
    const hasCyrillicInActive =
      cardLists?.rows?.some((card) => /[\u0400-\u04FF]/.test(card.title)) ??
      false;

    return hasCyrillicInActive ;
  },
);

